import { Injectable } from "@angular/core";
import { DataModel, MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { ViewTypesDataService } from "common/services/data-services/admin/view-type/view-types-data.services";
import { TypesModel } from "common/models/page-models/types/types-data-model";
import { TypesMetaModel } from "common/models/page-models/types/types-form-model";
import { SmMetaModel } from "common/models/utility-models/meta-model";
import { TypesFormDataService } from "common/services/data-services/admin/types/types-form-data.services";



@Injectable({
    providedIn: 'root'
})
export class TypesFormWidgetService extends FormWidgetService<TypesModel> {

    constructor(public ds: TypesFormDataService) {
        super(ds);
    }

    override prepareMetaModel(dataModel: TypesModel, metaModel: any, routeData: WidgetModel): Promise<TypesMetaModel> {
        return new Promise<TypesMetaModel>((resolve, reject) => {
            if (dataModel.type_name === "") {
                metaModel.properties.type_name.readOnly = false;
                metaModel.properties.type_name.propreadOnly = false;
                // metaModel.properties.catName.readOnly = false;
                // metaModel.properties.catName.propreadOnly = false;
            }
           
            resolve(metaModel);
        });
    }

    getMetaModel(): MetaModel {
        const meta = new TypesMetaModel();
        return meta.getMetaModel();
    }
}
